import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Application } from "@/types/startup";
import { useToast } from "@/hooks/use-toast";
import { ApplicationDetails } from "./ApplicationDetails";
import { handleApplicationAction } from "@/utils/applicationUtils";

interface ApplicationDialogProps {
  application: Application | null;
  onOpenChange: (open: boolean) => void;
  onStatusUpdate: (applicationId: string, status: string) => void;
}

export const ApplicationDialog = ({ 
  application, 
  onOpenChange,
  onStatusUpdate 
}: ApplicationDialogProps) => {
  const { toast } = useToast();

  const handleAction = async (status: string) => {
    if (!application) return;

    await handleApplicationAction(
      application,
      status,
      () => {
        toast({
          title: "Success",
          description: `Application ${status}`,
        });
        onStatusUpdate(application.id, status);
        onOpenChange(false);
      },
      (error) => {
        toast({
          title: "Error",
          description: error,
          variant: "destructive",
        });
      }
    );
  };

  if (!application) return null;

  return (
    <Dialog open={!!application} onOpenChange={onOpenChange}>
      <DialogContent className="bg-flux-black border-flux-cyan/20">
        <DialogHeader>
          <DialogTitle className="text-flux-cyan">Application Details</DialogTitle>
        </DialogHeader>
        <ApplicationDetails 
          application={application}
          onAction={handleAction}
        />
      </DialogContent>
    </Dialog>
  );
};